"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(shape) {
    var attrs = shape.attr();
    var x = attrs.x, y = attrs.y, width = attrs.width, height = attrs.height;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
    };
}
exports.default = default_1;
//# sourceMappingURL=rect.js.map